import Progressbar from "src/components/Progressbar";
import PanelLayout from "src/Layout/PanelLayout";
import Title from "src/components/Title";
import { useEffect, useState } from "react";
import Button from "src/components/Form/Button";
import Subheading from "src/components/Subheading";
import FormCheckbox from "src/components/Form/FormCheckbox";
import usePersistantState from "src/hooks/usePersistantState";
import CatchyCheckbox from "src/components/CatchyCheckbox/CatchyCheckbox";
import CheckBox from "src/components/Form/CheckBox";
import GridingCheckbox from "src/components/Form/GridingCheckbox";
import AfradeTahTSarparasti from "src/components/Form/AfradeTahTSarparasti";



export default function JobAnalysisPage5plus({ handleStep, handleStepDown }) {
    const [masouliatAmvalVaTajhizat, setMasouliatAmvalVaTajhizat] = usePersistantState("masouliatAmvalVaTajhizat", {
        "مسئولیت اموال و تجهیزات فیزیکی در اختیار (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const masouliatAmvalVaTajhizatOptions = {
        "تا 500،000،000 ریال": 0,
        "از 500000001 تا 100000000 ریال": 1,
        "از 100000001 تا 200000000 ریال": 2,
        "از 200000001 تا 300000000 ریال": 3,
        "از 300000001 ریال به بالا": 4,
    }


    const [majmooeTavanmadiha, setMajmooeTavanmadiha] = usePersistantState("majmooeTavanmadiha", {
        "با توجه به مجموع توانمندی های مورد نیاز ، کدامیک از گزینه های زیر برای این شغل صدق می نماید؟": {
            value: {},
            desc: "",
        }
    })
    const majmooeTavanmadihaOptions = {
        "مهارت‌های ساده": 0,
        "مهارت‌های نسبتا ساده": 1,
        "مهارت‌های نسبتا پیچیده": 2,
        "مهارت‌های پیچیده": 3,
        "مهارت‌های خیلی پیچیده": 4,
    }


    const [masouliatManabeMali, setMasouliatManabeMali] = usePersistantState("masouliatManabeMali", {
        "مسئولیت منابع مالی (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const masouliatManabeMaliOptions = {
        "مسئولیت مالی در خصوص مراقبت، نگهداری، دریافت و پرداخت وجوه نقد تا سقف 100 میلیون ریال و یا مسئولیت نگهداری، مراقبت، استفاده صحیح یا تغییر اثاثیه و ملزومات اداری تا سقف 100 میلیون ریال": 0,
        "مراقبت، نگهداری، دریافت، مصرف، خرید و فروش، تنظیم یا ثبت و صدور سند، پرداخت یا کنترل وجوه نقد به طور مستقل یا به صورت مشترک تا سقف 500 میلیون ریال یا در حد معاملات جزیی بر اساس آیین نامه معاملات و یا نگهداری، مراقبت، استفاده صحیح از اموال در اختیار تا سقف 500 میلیون ریال یا در حد معاملات متوسط": 1,
        "کنترل، دریافت و پرداخت یا مصرف وجوه نقد یا اوراق بهادار یا خرید و فروش و کسب درآمد بطور مستقل یا بصورت مشترک تا سقف 1000 میلیون ریال (یا در حد معاملات متوسط)، برآورد و تنظیم و تکمیل فرم های بودجه و یا نگهداری، مراقبت و استفاده صحیح از اموال در اختیار و نظایر آن تا سقف 1000 میلیون ریال": 2,
        "کنترل، دریافت، پرداخت یا مصرف وجوه نقد یا اوراق بهادار، خرید و فروش، تایید یا امضای چک و اسناد تعهد آور، انجام عملیات مالی بطور مستقل و یا به صورت مشترک تا سقف 1500 میلیون ریال (یا در حد معاملات عمده) در سطح یک حوزه فعالیت، برآورد و تایید نهایی فرم های بودجه و یا برنامه ریزی و نظارت بر نگهداری، مراقبت و استفاده صحیح از اموال منقول و غیر منقول تا سقف 1500 میلیون ریال": 3,
        "مسئولیت در قبال کنترل و امضای نهایی، دریافت و پرداخت و اجازه مصرف وجوه نقد، خرید و فروش یا امضای چک ها و اسناد تعهدآور و انجام کلیه امور مالی به طور مستقل در سطح سازمان، بیش از 1500 میلیون ریال و یا برنامه ریزی و نظارت بر نگهداری، مراقبت و استفاده صحیح از اموال منقول و غیر منقول بیش از 1500 میلیون ریال": 4,
    }


    const [masouliatMoghararat, setMasouliatMoghararat] = usePersistantState("masouliatMoghararat", {
        "مسئولیت مقررات ، روش‌ها و سیستم‌ها (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const masouliatMoghararatOptions = {
        "استفاده و بکارگیری دستورالعمل ها و رویه های ساده و یکنواخت ، اجرا و پیشنهاد در سطح درون سازمانی": 0,
        "استفاده و بکارگیری دستوالعمل ها و رویه های نسبتاً متنوع، تهیه و تدوین در سطح درون سازمانی": 1,
        "تهیه و تنظیم ، توضیح و تبیین دستورالعمل های متنوع ، نسبتاٌ پیچیده، بازنگری و پیشنهاد در اصلاح در سطح درون سازمانی": 2,
        "نظارت، بازنگری و اصلاح دستورالعمل ها، و روی های متنوع، و پیچیده، پیشنهاد در سطح درون سازمانی و برون سازمانی": 3,
        "مسئولیت پیشنهاد ، ابلاغ و تصویب مجموعه آیین نامه ها، دستورالعمل ها، و رویه ها و نظارت بر حسن اجرای آنها در سطوح ملی و بین المللی": 4,
    }



    const [controlKhataha, setControlKhataha] = usePersistantState("controlKhataha", {
        "کنترل خطاها و اشتباهات (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const controlKhatahaOptions = {
        "در صورت خطا یا اشتباه متصدی این شغل، عواقب یا زیان آنها متوجه شاغل می شود.": 0,
        "دارای مسئولیت هایی در ارتباط با نگهداری اطلاعات محرمانه بوده و در صورت خطا یا اشتباه عواقب و زیان آن علاوه بر شاغل متوجه واحد می شود.": 1,
        "دارای مسئولیت هایی هستند كه در صورت خطا یا اشتباه، عواقب و زیان آنها علاوه بر شاغل و واحد متوجه مدیریت نیز می شود.": 2,
        "دارای مسئولیت هایی هستند كه در صورت خطا یا اشتباه، عواقب و زیان آنها، علاوه بر شاغل، واحد و مدیریت ، متوجه معاونت نیز می شود.": 3,
        "خطا و اشتباه در آنها، دارای مسئولیت های برون سازمانی و درون سازمانی است.": 4,
    }



    const [gDamaneErtebati, setGDamaneErtebati] = usePersistantState("gDamaneErtebati", {
        "دامنه ارتباطی (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const gDamaneErtebatiOptions = {
        "ارتباط موثر با همکاران و ارباب رجوع": 0,
        "برای انجام وظایف جاری با خارج از سازمان جهت مذاکره، خرید و... نیز در ارتباط است.": 1,
        "علاوه بر افراد و سازمانها با روسای ادارت و موسسات خصوصی و دولتی به منظور تحقق اهداف سازمان در تعامل است.": 2,
        "علاوه بر موارد سطوح قبلی با مدیران عامل، و مقامات بالاتر جهت نیل به هدفهای اساسی سازمان در تعامل است.": 3,
        "علاوه بر موارد قبلی در سطوح ملی و بین المللی نیز با مدیران ارشد و روسای سازمانها ، نهادها ، وزارتخانه نیز در تعامل است.": 4,
    }


    const [stress, setStress] = usePersistantState("stress", {
        "استرس و شرایط غیر عادی كار (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const stressOptions = {
        "ضرورت حضور در محل كار یا تماس تلفنی در خارج از وقت اداریدر حداقل دفعاتی كه موجب اندكی نگرانی و سلب آسایش شود": 0,
        "استرس كم و ابهام و تضاد در نقش كم، تضاد در كار و خانواده كم و ضرورت حضور و تماس تلفنی خارج از وقت اداری به دفعات كم كه كمی موجب نگرانی می شود.": 1,
        "استرس، ابهام و تضاد كم، تماس تلفنی خارج از ساعات اداری به دفعات زیاد و آماده بكار بودن در خارج از ساعات اداری": 2,
        "استرس، ابهام و تضاد متوسط، ضرورت حضور در محل كار خارج از ساعات اداری به دفعات زیاد كه موجب سلب آسایش می‌شود": 3,
        "استرس ، ابهام و تضاد زیاد، ضرورت حضور در خارج از ساعات كاری بسیار بالا و در طول شبانه روز باعث سلب آسایش می‌شود.": 4,
    }


    const [argonomi, setArgonomi] = usePersistantState("argonomi", {
        " ایمنی، بهداشت محیط زیست و ارگونومی (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const argonomiOptions = {
        "علی رغم رعایت اصول ایمنی و مقررات بهداشتی، ممکن است موجب جراحات سطحی برای دیگران شوند": 0,
        "علی رغم رعایت اصول ایمنی و مقررات بهداشتی، ممکن است موجب جراحات عمیق برای دیگران شوند": 1,
        "علی رغم رعایت اصول ایمنی و مقررات بهداشتی، ممکن است موجب نقص عضو جزئی برای دیگران شوند": 2,
        "علی رغم رعایت اصول ایمنی و مقررات بهداشتی، ممکن است موجب نقص عضو کلی برای دیگران شوند": 3,
        "علی رغم رعایت اصول ایمنی و مقررات بهداشتی، ممکن است موجب از کار افتادگی و مرگ و میر دیگران شوند": 4,
    }
    const [khataratNashiAzKar, setKhataratNashiAzKar] = usePersistantState("khataratNashiAzKar", {
        "خطرات ناشی از کار": {
            value: {},
            desc: "",
        }
    })
    const khataratNashiAzKarOptions = {
       "صدمات یا جراحات سطحی و عمقی": 0,
       "نقص عضو جزئی": 1,
        "امراض جلدی، ریوی، عصبی، واریس، دیسک و روماتیسم": 2,
        "نقص عضو کلی": 3,
        "از کار افتادگی": 4,
    }
    const [sharayeteNamosaedeMohiteKar, setSharayeteNamosaedeMohiteKar] = usePersistantState("sharayeteNamosaedeMohiteKar", {
        "شرایط نامساعد محيط کار": {
            value: {},
            desc: "",
        }
    })
    const sharayeteNamosaedeMohiteKarOptions = {
       "دود و بخار و محیط آلوده": 0,
       "گرد و غبار و سر صدا": 1,
        "رطوبت، گرما، سرما، آفتاب و نور": 2,
       "بوی نامطبوع، و کارهای شیمیایی": 3,
       "لرزش، ارتعاش و اشعه": 4,
    }
    const [forms, setForms] = usePersistantState("forms", {
        "فرم ها و گزارشات  (لطفاً گزینه مناسب انتخاب شود) ‌ ‌": {
            value: {},
            desc: "",
        }
    })
    const formsOptions = {
      "تکمیل فرم های ساده و آمار": 0,
       "تنظیم فرم های مشل و پیچیده و تشخیص نوع وقایع": 1,
        "بررسی فرم های مشکل و پیچیده و تهیه گزارهای نسبتا مهم": 2,
       "جمع آوری، مقایسه ، محاسبه و تجزیه و تحلیل فرم ها و گزارشات و دسترسی به اطالعات محرمانه": 3,
       "بررسی و تجزیه و تحلیل فرم ها ، تهیه و تنظیم گزارشهای تحلیلی مهم حقوقی، اقتصادی، مالی ، تولیدی، فنی و اداری که منجر به تدوین خط و مشی کلان می شود.": 4,
    }


    const [koosheshEhsasi, setKoosheshEhsasi] = usePersistantState("koosheshEhsasi", {
        "كوشش احساسی (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const koosheshEhsasiOptions = {
        "شناخت و کنترل صحیح احساسات خود و دیگران در حد خیلی کم": 0,
        "شناخت و کنترل صحیح احساسات خود و دیگران در حد کم": 1,
        "شناخت و کنترل صحیح احساسات خود و دیگران در حد متوسط": 2,
        "شناخت و کنترل صحیح احساسات خود و دیگران در حد زیاد": 3,
        "شناخت و کنترل صحیح احساسات خود و دیگران در حد خیلی زیاد": 4,
    }



    const [koosheshJesmi, setKoosheshJesmi] = usePersistantState("koosheshJesmi", {
        "كوشش جسمی (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const koosheshJesmiOptions = {
        "بالا و پایین رفتن و خم و راست شدن و یا راه رفتن و ایستادن": 0,
        "تمرکز قوای سمعی و بصری": 1,
        "نشستن مداوم جهت کار با ماشین": 2,
        "حرکت بدنی مستلزم صرف نیروی جسمانی": 3,
        "جابجا کردن یا حمل و نقل اشیا بدون وسیله یا با وسیله": 4,
    }



    const [koosheshFekri, setKoosheshFekri] = usePersistantState("koosheshFekri", {
        "كوشش فكری، دقت و تمركز حواس (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const koosheshFekriOptions = {
        "شغل مستلزم كاربرد مهارتها و روش های ساده و تكراری بوده و نیاز كمی به دقت و تمركز حواس داشته و با ابزارهای ساده سر و كار دارد.": 0,
        "شغل مستلزم كاربرد مهارتها و روش های متعدد و یا پیچیده بوده و نیاز به دقت و تمركز حواس زیاد داشته و با ابزارهای دقیقی سر و كار دارد.": 1,
        "شغل مستلزم تجزیه و تحلیل مسائل مختلف بوده و نیاز به مهارتهای نسبتا پیچیده در تحلیل مسائل دارد.": 2,
        "شغل مستلزم تدوین روش های مختلف بوده، با مسائل پیچیده سر و كار داردو نیاز به ابتكار و خلاقیت بالا دارد.": 3,
        "شغل مستلزم حل مسائل پیچیده مدیریتی و عملیاتی بوده و نیاز به مهارتهای فكری بالا در تدوین راهبردهای سازمان دارد.": 4,
    }



    const [pasokhgooyi, setPasokhgooyi] = usePersistantState("pasokhgooyi", {
        "پاسخگویی (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const pasokhgooyiOptions = {
        "اندازه تاثیرات خیلی كم، نقش شغل در پیامدها و نتایج دور و غیر مستقیم": 0,
        "اندازه تاثیرات كم، نقش شاغل در پیامدها و نتایج نسبتاً دور و مشاركتی": 1,
        "اندازه تاثیرات متوسط، نقش شغل در پیامدها و نتایج نسبتاً مستقیم": 2,
        "اندازه تاثیرات زیاد، نقش شغل در پیامدها و نتایج مستقیم و مرتبط": 3,
        "اندازه تاثیرات خیلی زیاد، نقش شغل در پیامدها و نتایج كاملاً مستقیم ، كاملا مرتبط و مبنایی": 4,
    }
    const [masoliatKhas, setMasoliatKhas] = usePersistantState("masoliatKhas", {
        "مسئولیت خاص (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const masoliatKhasOptions = {
        "در صورت خطا یا اشتباه متصدی این شغل، عواقب یا زیان آنها متوجه شاغل می شود": 0,
        "دارای مسئولیت هایی در ارتباط با نگهداری اطالعات محرمانه بوده و در صورت خطا یا اشتباه عواقب و زیان آن عالوه بر شاغل متوجه واحد می شود.": 1,
       "دارای مسئولیت هایی هستند که در صورت خطا یا اشتباه، عاوقب و زیان آنها عالوه بر شاغل و واحد متوجه مدیریت نیز می شود.": 2,
        "دارای مسئولیت هایی هستند که در صورت خطا یا اشتباه، عواقب و زیان آنها، عالوه بر شاغل، واحد و مدیریت ، متوجه معاونت نیز می شود.": 3,
       "خطا و اشتباه در آنها، دارای مسئولیت های برون سازمانی و درون سازمانی است.": 4,
    }
   

    const [halemasale, setHalemasale] = usePersistantState("halemasale", {
        "حل مساله و تصمیم گیری (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const halemasaleOptions = {
        "مسائل و مشکلات تکراری و روتین و مشخص": 0,
        "مسائل و مشکلات نیمه روتین": 1,
        "مسائل و مشکلات استاندارد با رویه‌های نسبتا مشخص": 2,
        "مسائل و مشکلات تعریف شده واضح": 3,
        "مسائل و مشکلات بدون الگو، وسیع، کلی و انتزاعی": 4,
    }




    const [azadiAmal, setAzadiAmal] = usePersistantState("azadiAmal", {
        "استقلال و آزادی عمل (لطفاً گزینه مناسب انتخاب شود)": {
            value: {},
            desc: "",
        }
    })
    const azadiAmalOptions = {
        "اختیار محدود ، آزادی عمل کم، انجام کارها مطابق دستورالعمل": 0,
        "اختیار نسبتاً محدود ، آزادی عمل متوسط ، انجام کار بر اساس اصول استاندارد": 1,
        "اختیار و ابتکار عمل متوسط، آزادی عمل زیاد، انجام کار بر اساس اصول تنظیم شده کلی": 2,
        "اختیار زیاد، آزادی عمل خیلی زیاد، انجام کار بر اساس اصول هدایت شده و جهت دار": 3,
        "اختیار عمل نامحدود، آزادی عمل وسیع ، انجام کار بر اساس رهنمودهای کلی و گسترده": 4,
    }

    const [sarparastiMostaghim, setSarparastiMostaghim] = usePersistantState("sarparastiMostaghim", {
        "کارمند یا کارگر" : 0,
        "کمک کارشناس":0,
        "کارشناس":0,
        "کارشناس ارشد":0,
        "سطوح مدیریتی":0,
        
    })
    const [sarparastiGheireMostaghim, setSarparastiGheireMostaghim] = usePersistantState("sarparastiGheireMostaghim", {
        "کارمند یا کارگر"  : 0,
        "کمک کارشناس":0,
        "کارشناس":0,
        "کارشناس ارشد":0,
        "سطوح مدیریتی":0,
        
    })




    return (
        <PanelLayout>
            <Title title="تجزیه و تحلیل شغل" />
            <Progressbar activePart={5} handleStep={handleStep} />
            <div className="bg-white p-10 mx-28 shadow-lg border border-gray-200 rounded-lg">

                <Subheading title="قابلیت‌های مورد نیاز" isFirst={true} />
                <GridingCheckbox state={majmooeTavanmadiha} setState={setMajmooeTavanmadiha} givenOptions={majmooeTavanmadihaOptions} />


                <Subheading title="مسئولیت‌ها" isFirst={false} />
                <GridingCheckbox state={masouliatAmvalVaTajhizat} setState={setMasouliatAmvalVaTajhizat} givenOptions={masouliatAmvalVaTajhizatOptions} />
                <GridingCheckbox state={masouliatManabeMali} setState={setMasouliatManabeMali} givenOptions={masouliatManabeMaliOptions} />
                <GridingCheckbox state={masouliatMoghararat} setState={setMasouliatMoghararat} givenOptions={masouliatMoghararatOptions} />
                <GridingCheckbox state={controlKhataha} setState={setControlKhataha} givenOptions={controlKhatahaOptions} />
                <GridingCheckbox state={masoliatKhas} setState={setMasoliatKhas} givenOptions={masoliatKhasOptions} />
                <Subheading title="افراد تحت سرپرستی" isFirst={false} />
                <AfradeTahTSarparasti storageName={"sarparastiMostaghim"}  title={"سرپرستی مستقیم(لطفا تعداد افراد تحت سرپرستی را بنویسید)"} state={sarparastiMostaghim} setState={setSarparastiMostaghim} />
                <AfradeTahTSarparasti storageName={"sarparastiGheireMostaghim"}   title={"سرپرستی غیر مستقیم(لطفا تعداد افراد تحت سرپرستی را بنویسید)"} state={sarparastiGheireMostaghim} setState={setSarparastiGheireMostaghim} />

                <Subheading title="دامنه ارتباطی" isFirst={false} />
                <GridingCheckbox state={gDamaneErtebati} setState={setGDamaneErtebati} givenOptions={gDamaneErtebatiOptions} />
                <Subheading title="فرم‌ها و گزارشات" isFirst={false} />
                <GridingCheckbox state={forms} setState={setForms} givenOptions={formsOptions} />
            

                <Subheading title="مخاطرات و شرایط کاری" isFirst={false} />
                <GridingCheckbox state={stress} setState={setStress} givenOptions={stressOptions} />
                <GridingCheckbox state={argonomi} setState={setArgonomi} givenOptions={argonomiOptions} />
                <GridingCheckbox state={khataratNashiAzKar} setState={setKhataratNashiAzKar} givenOptions={khataratNashiAzKarOptions} />
                <GridingCheckbox state={sharayeteNamosaedeMohiteKar} setState={setSharayeteNamosaedeMohiteKar} givenOptions={sharayeteNamosaedeMohiteKarOptions} />
            
             
                <Subheading title="کوشش‌های شغلی" isFirst={false} />
                <GridingCheckbox state={koosheshEhsasi} setState={setKoosheshEhsasi} givenOptions={koosheshEhsasiOptions} />
                <GridingCheckbox state={koosheshJesmi} setState={setKoosheshJesmi} givenOptions={koosheshJesmiOptions} />
                <GridingCheckbox state={koosheshFekri} setState={setKoosheshFekri} givenOptions={koosheshFekriOptions} />


                <Subheading title="پاسخگویی و حل مسئله" isFirst={false} />
                <GridingCheckbox state={pasokhgooyi} setState={setPasokhgooyi} givenOptions={pasokhgooyiOptions} />
                <GridingCheckbox state={halemasale} setState={setHalemasale} givenOptions={halemasaleOptions} />
                <GridingCheckbox state={azadiAmal} setState={setAzadiAmal} givenOptions={azadiAmalOptions} />


                <div className="flex justify-center items-center relative mt-10 z-50">
                    <Button isPrevious={true} title="مرحله قبل" direction="center" handleClick={(event) => handleStepDown()} color="#f9b302" />
                    <Button title="ثبت اطلاعات و تکمیل فرم بعدی" direction="center" handleClick={(event) => handleStep()} />
                </div>
            </div>
        </PanelLayout>
    )
}